import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';

const NoticeList = ({ apiRef, columns, rows, loading, handleRowClick }) => {
  const [pageSize, setPageSize] = React.useState(20);

  return (
    <div style={{ display: 'flex', height: '743px' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGridPro
          rows={rows ? rows : []}
          columns={columns}
          loading={loading}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
          onRowClick={(params, e) => handleRowClick(e, params)}
        />
      </div>
    </div>
  )
}

export default NoticeList